import {Button, Grid, InputLabel, MenuItem, OutlinedInput, Select} from "@material-ui/core";
import PermPhoneMsgIcon from "@material-ui/icons/PermPhoneMsg";
import {Trans} from "../../utils/i18n";
import Publish from "@material-ui/icons/Publish";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import GetApp from "@material-ui/icons/GetApp";
import React from "react";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import styled, {css} from "styled-components";
import useFilterConfig from "../../config/queues/useFilterConfig";
import i18n from "i18next";

const TabLink = styled.div`
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
    text-align: center;
    padding: 30px;
    font-size: 20px;
    display: block;
    text-decoration: none;
    color: ${(props) => props.theme.secondary};
    cursor: pointer;
    ${(props) =>
    props.$active &&
    css`
        background-color: ${(props) => props.theme.primary};
        color: white;
    `}
`;

const H1 = styled.h1`
    display: inline-block;
    margin-right: 30px;
`;


export default function QueueFilter ({ updatePage, filterData, }) {
    const { permissions, requesttypes, active_requesttype, partners, companies, client, products, locker_service_types } = usePage().props;
    const filterConfig = useFilterConfig();

    return (
        <div>
            <Grid container spacing={3} alignItems="center">
                {permissions.includes("queue_agent") && (
                    <Grid
                        item
                        xs={4}
                        style={{
                            marginBottom: 30,
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            endIcon={
                                <PermPhoneMsgIcon>
                                    <Trans i18nKey="queues.agentButton">
                                        Open Chat
                                    </Trans>
                                </PermPhoneMsgIcon>
                            }
                            href={route("admin.agent")}
                            target="_blank"
                        >
                            <Trans i18nKey="queues.agentButton">
                                Open Chat
                            </Trans>
                        </Button>
                    </Grid>
                )}
                    <Grid item xs={12}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <H1>
                                <Trans i18nKey="queues">Queues</Trans>
                            </H1>
                            {permissions.includes("queue_import") && (
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        endIcon={
                                            <Publish>
                                                <Trans i18nKey="queues.send">
                                                    send
                                                </Trans>
                                            </Publish>
                                        }
                                        component={InertiaLink}
                                        href={route("queue.import")}
                                    >
                                        <Trans i18nKey="queues.import">
                                            Import
                                        </Trans>
                                    </Button>
                                )
                            }
                        </div>
                    </Grid>
            </Grid>

            <div className={'grid grid-cols-12 gap-3'}>
                {
                    filterConfig
                        .filter((item) => item.condition !== undefined ? item.condition : true)
                        .map((item) => {
                        if(item.name === 'requesttypes') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <Grid container spacing={3}>
                                        {
                                            requesttypes.map((item) => (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={requesttypes.length > 3 ? 3 : 4}
                                                    key={item.key}
                                                >
                                                    <TabLink
                                                        onClick={() => {
                                                            updatePage({requesttype: item.key,});
                                                        }}
                                                        $active={active_requesttype === item.key}
                                                    >
                                                        {item.name}
                                                    </TabLink>
                                                </Grid>
                                            ))}
                                    </Grid>
                                </div>
                            );
                        }
                        if(item.name === 'search') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                        <TextField
                                            id="email"
                                            label={
                                                <Trans i18nKey="common.search">Search</Trans>
                                            }
                                            value={filterData.search}
                                            onChange={(e) => updatePage( { search: e.target.value } )}
                                            name="search"
                                            type="text"
                                            variant="outlined"
                                        />
                                </div>
                            );
                        }
                        if(item.name === 'service') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <FormControl variant="outlined">
                                        <InputLabel id="filter-client">
                                            <Trans i18nKey="queues.service">Service</Trans>
                                        </InputLabel>
                                        <Select
                                            labelId="filter-client"
                                            label={
                                                <Trans i18nKey="queues.service">
                                                    Service
                                                </Trans>
                                            }
                                            value={filterData.service}
                                            onChange={(e) => updatePage( { service: e.target.value } )}
                                        >
                                            <MenuItem value="all">
                                                <Trans i18nKey="queues.all">All</Trans>
                                            </MenuItem>
                                            {requesttypes
                                                .reduce(
                                                    (carry, item) => [
                                                        ...carry,
                                                        ...item.services,
                                                    ],
                                                    []
                                                )
                                                .reduce((carry, item) => {
                                                    if (
                                                        !carry.find(
                                                            (arrayItem) =>
                                                                arrayItem.id === item.id
                                                        )
                                                    ) {
                                                        carry.push(item);
                                                    }
                                                    return carry;
                                                }, [])
                                                .map((service) => {
                                                    return (
                                                        <MenuItem
                                                            key={service.id}
                                                            value={service.id}
                                                        >
                                                            {service.name}
                                                        </MenuItem>
                                                    );
                                                })}
                                            <MenuItem value="noservice">
                                                <Trans i18nKey="services.noservice">
                                                    No service
                                                </Trans>
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if(item.name === 'status') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <FormControl variant="outlined">
                                        <InputLabel id="status-name-label">
                                            <Trans i18nKey="queues.status">Status</Trans>
                                        </InputLabel>
                                        <Select
                                            labelId="status-name-label"
                                            id="status-select"
                                            multiple
                                            value={filterData.status}
                                            onChange={(event) => {
                                                const {
                                                    target: { value },
                                                } = event;
                                                updatePage({ status: typeof value === 'string' ? value.split(',') : value });
                                            }}
                                            input={<OutlinedInput label={<Trans i18nKey="queues.status">Status</Trans>} />}
                                        >
                                            {requesttypes
                                                .reduce(
                                                    (carry, item) => [
                                                        ...carry,
                                                        ...item.services,
                                                    ],
                                                    []
                                                )
                                                .reduce(
                                                    (carry, item) => [
                                                        ...carry,
                                                        ...item.statuses,
                                                    ],
                                                    []
                                                )
                                                .reduce((carry, item) => {
                                                    if (
                                                        !carry.find(
                                                            (arrayItem) =>
                                                                arrayItem.id === item.id
                                                        )
                                                    ) {
                                                        carry.push(item);
                                                    }
                                                    return carry;
                                                }, [])
                                                .map((status) => {
                                                    return (
                                                        <MenuItem
                                                            key={status.id}
                                                            value={status.id}
                                                        >
                                                            {status.name}
                                                        </MenuItem>
                                                    );
                                                })}
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if(item.name === 'partner') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <FormControl variant="outlined">
                                        <InputLabel id="filter-partner"><Trans i18nKey="queues.partner">Partner</Trans></InputLabel>
                                        <Select
                                            labelId="filter-partner"
                                            label={
                                                <Trans i18nKey="queues.partner">
                                                    Partner
                                                </Trans>
                                            }
                                            value={filterData.partner}
                                            onChange={(e) => updatePage( { partner: e.target.value } )}
                                        >
                                            <MenuItem value="all">
                                                <Trans i18nKey="queues.all">All</Trans>
                                            </MenuItem>
                                            {partners.map((status) => {
                                                return (
                                                    <MenuItem
                                                        key={status.id}
                                                        value={status.id}
                                                    >
                                                        {status.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if(item.name === 'locker_service_type') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <FormControl variant="outlined">
                                        <InputLabel id="filter-locker_service_type"><Trans i18nKey="locker_service_type">Locker Service Type</Trans></InputLabel>
                                        <Select
                                            labelId="filter-locker_service_type"
                                            label={
                                                <Trans i18nKey="locker_service_type">
                                                    Locker Service Type
                                                </Trans>
                                            }
                                            value={filterData.locker_service_type}
                                            onChange={(e) => updatePage( { locker_service_type: e.target.value } )}
                                        >
                                            <MenuItem value="all">
                                                <Trans i18nKey="queues.all">All</Trans>
                                            </MenuItem>
                                            {locker_service_types.map((type) => {
                                                return (
                                                    <MenuItem
                                                        key={type.value}
                                                        value={type.value}
                                                    >
                                                        {type.value}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if(item.name === 'product') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <FormControl variant="outlined">
                                        <InputLabel id="filter-product"><Trans i18nKey="queues.product">Product</Trans></InputLabel>
                                        <Select
                                            labelId="filter-product"
                                            label={
                                                <Trans i18nKey="queues.product">
                                                    Product
                                                </Trans>
                                            }
                                            value={filterData.product}
                                            onChange={(e) => updatePage( { product_id: e.target.value } )}
                                        >
                                            <MenuItem value="all">
                                                <Trans i18nKey="queues.all">All</Trans>
                                            </MenuItem>
                                            {products.map((product) => {
                                                return (
                                                    <MenuItem
                                                        key={product.id}
                                                        value={product.id}
                                                    >
                                                        {product.description}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if(item.name === 'company') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <FormControl variant="outlined">
                                        <InputLabel id="filter-company"><Trans i18nKey="queues.company">Company</Trans></InputLabel>
                                        <Select
                                            labelId="filter-company"
                                            label={
                                                <Trans i18nKey="queues.company">
                                                    Company
                                                </Trans>
                                            }
                                            value={filterData.company}
                                            onChange={(e) => updatePage( { company: e.target.value } )}
                                        >
                                            <MenuItem value="all">
                                                <Trans i18nKey="queues.all">All</Trans>
                                            </MenuItem>

                                            {companies.map((company) => {
                                                return (
                                                    <MenuItem
                                                        key={company.id}
                                                        value={company.id}
                                                    >
                                                        {company.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if(item.name === 'appointmentStatus') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <FormControl variant="outlined">
                                        <InputLabel id="appointment-status-name-label">
                                            <Trans i18nKey="queueDetail.appointment.status">Appointment Status</Trans>
                                        </InputLabel>
                                        <Select
                                            labelId="appointment-status-name-label"
                                            id="demo-multiple-name"
                                            multiple
                                            value={filterData.appointmentStatus}
                                            onChange={(event) => {
                                                const {
                                                    target: { value },
                                                } = event;
                                                updatePage({ appointmentStatus: typeof value === 'string' ? value.split(',') : value });
                                            }}
                                            input={<OutlinedInput label={<Trans i18nKey="queueDetail.appointment.status">Appointment Status</Trans>} />}
                                        >
                                            <MenuItem value="open">
                                                { i18n.t(`appointment.status.open`) }
                                            </MenuItem>
                                            <MenuItem value="customerNotAvailable">
                                                { i18n.t(`appointment.status.customerNotAvailable`) }
                                            </MenuItem>
                                            <MenuItem value="completed">
                                                { i18n.t(`appointment.status.completed`) }
                                            </MenuItem>
                                            <MenuItem value="cancelled">
                                                { i18n.t(`appointment.status.cancelled`) }
                                            </MenuItem>
                                            <MenuItem value="failed">
                                                { i18n.t(`appointment.status.failed`) }
                                            </MenuItem>
                                            <MenuItem value="Back2Sales">
                                                Back2Sales
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if(item.name === 'channel') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <FormControl variant="outlined">
                                        <InputLabel id="filter-channel">
                                            <Trans i18nKey="queues.channel">Channel</Trans>
                                        </InputLabel>
                                        <Select
                                            labelId="filter-channel"
                                            label={
                                                <Trans i18nKey="queues.channel">
                                                    Channel
                                                </Trans>
                                            }
                                            value={filterData.channel}
                                            onChange={(e) => updatePage( { channel: e.target.value } )}
                                        >
                                            <MenuItem value="all">
                                                <Trans i18nKey="queues.all">All</Trans>
                                            </MenuItem>
                                            <MenuItem value="B2B">
                                                B2B
                                            </MenuItem>
                                            <MenuItem value="B2C">
                                                B2C
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if(item.name === 'dateOfService' || item.name === 'appointmentDate') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            clearable
                                            inputVariant="outlined"
                                            label={
                                                item.name === 'appointmentDate' ?
                                                <Trans i18nKey="queueDetail.appointment.label">Appointment</Trans>
                                                :
                                                <Trans i18nKey="queues.dateOfService">
                                                    Date of service
                                                </Trans>
                                            }
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={filterData[item.name]}
                                            onChange={(value) => {
                                                if (value === null) {
                                                    updatePage({[item.name]: null});
                                                }
                                                if (
                                                    Object.prototype.toString.call(value) === "[object Date]" &&
                                                    !isNaN(value.getTime())
                                                ) {
                                                    updatePage({[item.name]: value});
                                                }
                                            }}
                                            format="dd.MM.yyyy"
                                            autoOk={true}
                                            error={false}
                                            invalidDateMessage={<span></span>}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            );
                        }
                        if(item.name === 'dateFrom') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            clearable
                                            inputVariant="outlined"
                                            label={
                                                <Trans i18nKey="queues.from">
                                                    From
                                                </Trans>
                                            }
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            // placeholder="10.10.2021"
                                            value={filterData.dateFrom}
                                            onChange={(value) => {
                                                if (value === null) {
                                                    updatePage({dateFrom: null});
                                                }
                                                if (
                                                    Object.prototype.toString.call(value) === "[object Date]" &&
                                                    !isNaN(value.getTime())
                                                ) {
                                                    updatePage({dateFrom: value});
                                                }
                                            }}
                                            format="dd.MM.yyyy"
                                            autoOk={true}
                                            error={false}
                                            invalidDateMessage={<span></span>}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            );
                        }
                        if(item.name === 'dateTo') {
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            clearable
                                            inputVariant="outlined"
                                            label={
                                                <Trans i18nKey="queues.to">To</Trans>
                                            }
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={filterData.dateTo}
                                            onChange={(value) => {
                                                if (value === null) {
                                                    updatePage({dateTo: null});
                                                }
                                                if (
                                                    Object.prototype.toString.call(value) === "[object Date]" &&
                                                    !isNaN(value.getTime())
                                                ) {
                                                    updatePage({dateTo: value});
                                                }
                                            }}
                                            format="dd.MM.yyyy"
                                            autoOk={true}
                                            error={false}
                                            invalidDateMessage={<span></span>}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            );
                        }
                        if(item.name === 'queue_export') {
                            const downloadUrl = new URL(window.location.href);
                            downloadUrl.searchParams.append("print", "");
                            return (
                                <div className={item.columnClassName} key={item.name}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        endIcon={<GetApp>send</GetApp>}
                                        href={downloadUrl.href}
                                    >
                                        <Trans i18nKey="queues.download">
                                            Download
                                        </Trans>
                                    </Button>
                                </div>
                            );
                        }
                    })
                }
            </div>
        </div>
    );
}
